// src/Components/Footer.jsx
import React, {
  useState,
  useCallback,
  useRef,
  useEffect
} from "react";
import {
  createPortal
} from "react-dom";
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import {
  FaVideo,
  FaSearch,
  FaHistory,
  FaPlayCircle
} from "react-icons/fa";
import {
  FiVideo,
  FiSearch,
  FiClock,
  FiPlayCircle
} from "react-icons/fi";
import "./Footer.css";

export default function Footer( {
  isVisible = true
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const normalize = (p) => (p || "/").toLowerCase();

  const [activePath,
    setActivePath] = useState(normalize(location.pathname));
  const [portalNode,
    setPortalNode] = useState(null);
  const lastClickTime = useRef(0);

  useEffect(() => {
    setActivePath(normalize(location.pathname));
  }, [location.pathname]);

  // Create portal node once (appends to body)
  useEffect(() => {
    let node = document.getElementById("vitstra-footer-portal");
    if (!node) {
      node = document.createElement("div");
      node.id = "vitstra-footer-portal";
      document.body.appendChild(node);
    }
    setPortalNode(node);
  },
    []);

  const makeClickHandler = useCallback(
    (targetPath) =>
    () => {
      const now = Date.now();
      const delta = now - lastClickTime.current;

      if (activePath === targetPath && delta < 400) {
        window.scrollTo({
          top: 0, behavior: "smooth"
        });
      } else {
        navigate(targetPath);
      }

      lastClickTime.current = now;
    },
    [activePath,
      navigate]
  );

  if (!isVisible) return null;
  if (!portalNode) return null;

  const isShorts = (p) => ["/",
    "/short",
    "/shorts"].includes(normalize(p));

  return createPortal( < footer className = "premium-footer" role = "contentinfo" aria-label = "App footer" >
    <div
      className={`footer-item ${isShorts(activePath) ? "active": ""}`}
      onClick={makeClickHandler("/")}
      >
      {isShorts(activePath) ? <FaPlayCircle className="footer-icon" />: <FiPlayCircle className="footer-icon" />}
    </div>

    <div
      className={`footer-item ${activePath === "/videos" ? "active": ""}`}
      onClick={makeClickHandler("/videos")}
      >
      {activePath === "/videos" ? <FaVideo className="footer-icon" />: <FiVideo className="footer-icon" />}
    </div>

    <div className={`footer-ai-button ${activePath === "/ai" ? "active": ""}`} onClick={() => navigate("/ai")}>
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <rect x="8" y="12" width="24" height="18" rx="6" stroke="currentColor" strokeWidth="2" fill="none" />
        <circle cx="15" cy="21" r="2" fill="currentColor" />
        <circle cx="25" cy="21" r="2" fill="currentColor" />
        <line x1="20" y1="6" x2="20" y2="12" stroke="currentColor" strokeWidth="2" />
        <circle cx="20" cy="6" r="2" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    </div>

    <div className={`footer-item ${activePath === "/search" ? "active": ""}`} onClick={() => navigate("/search")}>
      {activePath === "/search" ? <FaSearch className="footer-icon" />: <FiSearch className="footer-icon" />}
    </div>

    <div className={`footer-item ${activePath === "/history" ? "active": ""}`} onClick={() => navigate("/history")}>
      {activePath === "/history" ? <FaHistory className="footer-icon" />: <FiClock className="footer-icon" />}
    </div>
  </footer>,
  portalNode
);
}